import { router, usePage } from "@inertiajs/react"
import { MailWarning, X } from "lucide-react"
import { useState } from "react"
import type { SharedProps } from "@/types/inertia"

export function VerificationBanner() {
  const { current_user, email_verified } = usePage<SharedProps>().props
  const [dismissed, setDismissed] = useState(false)

  if (!current_user || email_verified || dismissed) return null

  function resend() {
    router.post("/email_verification", {}, { preserveScroll: true })
    setDismissed(true)
  }

  return (
    <div className="bg-amber-50 dark:bg-amber-950/40 border-b border-amber-200 dark:border-amber-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3">
        <MailWarning className="w-4 h-4 text-amber-600 dark:text-amber-400 shrink-0" />
        <p className="text-sm text-amber-800 dark:text-amber-300 flex-1">
          Please verify your email address.{" "}
          <button
            onClick={resend}
            className="underline font-medium hover:no-underline"
          >
            Resend verification email
          </button>
        </p>
        <button
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          className="text-amber-500 hover:text-amber-700 dark:hover:text-amber-300 shrink-0"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}
